import { initializeApp, getApps, FirebaseApp } from 'firebase/app'
import { getAuth, Auth, connectAuthEmulator, setPersistence, browserLocalPersistence } from 'firebase/auth'
import { getFirestore, Firestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getStorage, FirebaseStorage, connectStorageEmulator } from 'firebase/storage'
import { getFunctions, connectFunctionsEmulator, Functions } from 'firebase/functions'

// Firebase設定
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

// Firebase初期化（重複初期化を防ぐ）
let app: FirebaseApp
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig)
} else {
  app = getApps()[0]
}

// 各サービスの初期化
export const auth: Auth = getAuth(app)
// 永続性を明示的に設定（ブラウザを閉じても維持）
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Failed to set auth persistence:', error)
})

export const db: Firestore = getFirestore(app)
export const storage: FirebaseStorage = getStorage(app)
export const functions: Functions = getFunctions(app, 'asia-northeast1')

// エミュレータに接続（環境変数で制御）
const useEmulator = import.meta.env.VITE_USE_EMULATOR === 'true'
const emulatorHost = import.meta.env.VITE_EMULATOR_HOST || 'localhost'
const emulatorAuthPort = Number(import.meta.env.VITE_EMULATOR_AUTH_PORT || '9099')
const emulatorFirestorePort = Number(import.meta.env.VITE_EMULATOR_FIRESTORE_PORT || '8080')
const emulatorStoragePort = Number(import.meta.env.VITE_EMULATOR_STORAGE_PORT || '9199')
const emulatorFunctionsPort = Number(import.meta.env.VITE_EMULATOR_FUNCTIONS_PORT || '5001')

if (useEmulator) {
  try {
    // エミュレータに接続（既に接続済みの場合はエラーになるが、無視する）
    connectAuthEmulator(auth, `http://${emulatorHost}:${emulatorAuthPort}`, { disableWarnings: true })
  } catch (error) {
    // 既に接続済みの場合はエラーを無視
    console.log('Auth emulator already connected or connection failed')
  }
  
  try {
    connectFirestoreEmulator(db, emulatorHost, emulatorFirestorePort)
  } catch (error) {
    // 既に接続済みの場合はエラーを無視
    console.log('Firestore emulator already connected or connection failed')
  }
  
  try {
    connectStorageEmulator(storage, emulatorHost, emulatorStoragePort)
  } catch (error) {
    // 既に接続済みの場合はエラーを無視
    console.log('Storage emulator already connected or connection failed')
  }

  try {
    connectFunctionsEmulator(functions, emulatorHost, emulatorFunctionsPort)
  } catch (error) {
    console.log('Functions emulator already connected or connection failed')
  }
}

export default app

